import { OktaAuth } from "@okta/okta-auth-js";

import { AppRoute } from "@/types/routes";

/**
 * Computed from the current origin (instead of a per-env `VITE_...` var) because dev/stage/prod
 * and localhost all share a single Okta Client ID: whichever origin the app is loaded from must be
 * registered as a redirect URI on that one Okta app for the code exchange to succeed.
 */
const redirectUri = `${globalThis.location.origin}${AppRoute.LoginCallback}`;

const oktaAuth = new OktaAuth({
  issuer: import.meta.env.VITE_PUBLIC_AUTH_OKTA_ISSUER,
  clientId: import.meta.env.VITE_PUBLIC_AUTH_OKTA_ID,
  redirectUri,
  scopes: ["openid", "profile", "email"],
  pkce: true,
  tokenManager: {
    autoRenew: true,
    autoRemove: true,
    expireEarlySeconds: 120,
    storage: "localStorage"
  }
});

/** Current Okta access token, if any (does not trigger a renewal). Handy for one-off/manual `fetch` calls, e.g. in dev-only test pages. */
async function getOktaAccessToken(): Promise<string | null> {
  const token = await oktaAuth.tokenManager.get("accessToken");
  return token && "accessToken" in token ? token.accessToken : null;
}

export { oktaAuth, getOktaAccessToken };
